import BaseContainer from "@base/container/BaseContainer";
import Facade from "@/Facade";
import {Signals} from "@/Imports";

export default class RewardContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init(data)
  }

  init(data) {
    Signals.stopFeature.add(this.onStopFeature, this)
    Signals.showfreebets.add(this.onShowfreebets, this)
  }

  onShowfreebets(value) {
  }

  onStopFeature(currentBonus) {
  }
}
